import React, { useState, useEffect } from 'react';
import ModalPortal from 'components/Modal';
import { ModalApagarTarjeta } from 'pages/Credito/7-Modals';
import { getCardStatus } from 'services/Cards'
import { useIsMobile } from 'hooks/useIsMobile';
import Styles from './styles.module.sass'

import { dataLayerButtons } from 'functions/dataLayerFunction'
import useTokenNew from 'newHooks/useTokenNew';


export function CheckStatusCard(props){
    const {
        dataSaldos
    } = props
    const { isMobile } = useIsMobile();
    const { validAction, isValid } = useTokenNew({name: 'CheckStatusCard' })

    const [ showModalApagarTarjeta, SetShowModalApagarTarjeta ] = useState(false);
    const [ prender, setPrender ] = useState(false);
    const [ checkActivate, setCheckActivate ] = useState(false);

    // cerrar modal de tarjeta duplicada
    const handleClose = () => SetShowModalApagarTarjeta(false);

    useEffect(()=>{
        if(dataSaldos?.status === 1 || dataSaldos?.status === 0){
            if(dataSaldos?.status === 1){
                setPrender(true)
            }
            else if(dataSaldos?.status === 0){
                setPrender(false)
            }
        }
    },[ dataSaldos?.status ])

    // realiza encendio / apagado de la tarjeta
    const [responseActive, setResponseActive] = useState()
    const handlePrenderApagar = () => {
        if(dataSaldos?.status === 1 || dataSaldos?.status === 0 ){
             setPrender(!prender);
             if (prender === true) {
                SetShowModalApagarTarjeta(true);
             }
             else{
                // validAction()
                setCheckActivate({
                    active: 1
                })
             }
         }
    };

    // no deseo  apagar la tarjeta (modal)
    const noRemove = () => {
        SetShowModalApagarTarjeta(false);
        setPrender(true)
    };
    
    // si deseo  apagar la tarjeta (modal)
    const siRemove = () => {
        SetShowModalApagarTarjeta(false);
        // validAction()
        setCheckActivate({
            active: 0
        })
        setPrender(false)
    };

    useEffect(()=>{
        if(checkActivate){
            if(isValid){
                getCardStatus({dataCard:{cardending: dataSaldos.cardending, no_internet: dataSaldos.noInternet, active: checkActivate.active}})
                .then(setResponseActive)
                setCheckActivate(false)
            }
        }
    },[ isValid, checkActivate ])

    useEffect(()=>{
        if(responseActive){
            if(prender){
                dataLayerButtons({eventName: "credito_prender"})
                console.log('prender')
            }else{
                dataLayerButtons({eventName: "credito_apagar"})
                console.log('apagar')
            }
        }
    },[responseActive])

    return(
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ?
                        <div className={Styles?.boxApagarDesk}>
                            <label htmlFor="prender" className={Styles?.prender}>{prender === true ? "Desactivar" : "Activar"}</label>
                            <label className={Styles?.swich}>
                                <input id="prender" type="checkbox" className={Styles?.input} checked={prender} onChange={handlePrenderApagar}></input>
                                <div className={Styles?.toggle}>
                                    <span className={Styles?.selector}></span>
                                </div>
                            </label>
                        </div>
                    :
                        <div className={Styles?.opcApagar}>
                            <span>{prender === true ? "Apagar" : "Prender"}</span>
                            <label>
                                <input type="checkbox" className={Styles?.input} checked={prender} onChange={handlePrenderApagar}></input>
                                <div className={Styles?.toggle}>
                                    <span className={Styles?.selector}></span>
                                </div>
                            </label>
                        </div>
                : null
            }
            
            {showModalApagarTarjeta &&
                <ModalPortal type="modalSB" onClose={handleClose} >
                    <ModalApagarTarjeta remvoeAction={siRemove} awaitAction={noRemove}
                        title="Apagar tarjeta"
                        body="Si no encuentras tu tarjeta física, puedes apagar tu tarjeta y evitarás que se realicen cargos. Podrás encenderla en cualquier momento."
                        subBody="¿Deseas apagarla temporalmente?" />
                </ModalPortal>
            }
        </>
    )
}